export default __webpack_public_path__ + "static/media/over-axlesGroup-size.6770dbd1.svg";